import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './Drawer.module.scss'

const Drawer = ({ onClose, avatar, title, subtitle, children }) => (
  <>
    <aside className={classNames(classes.drawer, 'd-flex flex-column')}>
      <header className={classNames(classes.header, 'd-flex align-items-center')}>
        {avatar}
        <div className={classNames(classes.heading, 'flex-grow-1')}>
          <h5 className={classNames(classes.title, 'mb-0')}>{title}</h5>
          {subtitle && <div className={classNames(classes.subtitle, 'mt-1')}>{subtitle}</div>}
        </div>
        <button className={classes.closeButton} onClick={onClose}>
          <i className='fa fa-times' aria-hidden='true' />
        </button>
      </header>
      <div className={classNames(classes.body, 'd-flex flex-column')}>{children}</div>
    </aside>
    <div
      tabIndex={0}
      role='button'
      onKeyDown={() => null}
      className={classes.drawerOverlay}
      onClick={onClose}
    />
  </>
)

Drawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  avatar: PropTypes.node,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node.isRequired,
}

export default Drawer
